/**
 * Cookie Banner
 */

/*
 Connections:
 -------------------------------------------------------------------------------
 * players - every player on website: Vimeo, YouTube
 * newsletter - MailerLite forms
 * google - GTM code
 * facebook - Facebook Pixel
*/

class TJ_CookieBanner {
  constructor() {
    this.config = {
      debugMode: true,
      userConsents: {
        google: false
      },
      userUUID: 'not-set',
      groups: [
        'google'
      ]
    };

    this.UI = {
      basicWindow: $('.tomjak-cn-info'),
      extendedWindow: $('.tomjak-cn-info-extended'),
      buttons: {
        basicShowExtended: $('.tomjak-cn-info-button-show-extended'),
        basicAcceptAll: $('.tomjak-cn-info-button-accept-all'),
        basicRejectAll: $('.tomjak-cn-info-button-reject-all'),
        extendedAcceptAll: $('.tomjak-cn-info-extended-button-accept-all'),
        extendedSaveConfig: $('.tomjak-cn-info-extended-button-save-consent'),
        extendedNotNow: $('.tomjak-cn-info-extended-button-close-without-save')
      },
      checkboxes: {
        google: $('.tomjak-cn-consent-checkbox[data-consent-type="google"]')
      }
    };

    this.initEvents();
    this.initPublicAPI();
    this.checkConfig();
  }

  checkConfig () {
    let config = Cookies.get('fwk-cn-config-v1');

    // When no config - show popup
    if (!config) {
      if (this.config.debugMode) {
        console.log('⛔️ Consent config not found - showing popup');
      }

      this.config.userUUID = this.generateUUID();
    
      // Not open on privacy policy page
      if (!$(document.body).hasClass('privacy-policy')) {
        this.showPopup();
      }

      return;
    }

    // otherwise - load config without showing popup
    this.loadConfig(config);
  }

  loadConfig (configFromCookie) {
    this.config.userConsents.google = configFromCookie.indexOf('google') > -1;
    let configParts = configFromCookie.split('||');

    if (configParts[1]) {
        this.config.userUUID = configParts[1].replace(/[^a-zA-Z0-9\-]/gmi, '');
    } else {
        this.config.userUUID = this.generateUUID();
    }

    if (this.config.debugMode) {
      console.log('⚙️ Founded config:', JSON.parse(JSON.stringify(this.config.userConsents)));
    }
  }

  initEvents () {
    $(document).find('a[href="#cookie-settings"]').on('click', e => {
      e.preventDefault();
      this.showExtendedPopup();
    });

    this.UI.buttons.basicShowExtended.on('click', e => {
      e.preventDefault();
      this.closePopup();
      this.showExtendedPopup();
    });

    this.UI.buttons.basicAcceptAll.on('click', e => {
      e.preventDefault();
      this.giveConsentForAll();
      this.closePopup();
    });

    this.UI.buttons.basicRejectAll.on('click', e => {
      e.preventDefault();
      this.resetCookieConfig();
      this.closePopup();
    });

    this.UI.buttons.extendedAcceptAll.on('click', e => {
      e.preventDefault();
      this.giveConsentForAll();
      this.closeExtendedPopup();
    });

    this.UI.buttons.extendedSaveConfig.on('click', e => {
      e.preventDefault();
      this.saveConsent();
      this.closeExtendedPopup();
    });

    this.UI.buttons.extendedNotNow.on('click', e => {
      e.preventDefault();
      this.closeExtendedPopup();

      var configFromCookie = Cookies.get('fwk-cn-config-v1');
  
      if (!configFromCookie) {
        this.showPopup();
      }
    });
  }

  setCheckboxes () {
    for (let i = 0; i < this.config.groups.length; i++) {
      let group = this.config.groups[i];
      
      if (this.config.userConsents[group]) {
        this.UI.checkboxes[group].prop('checked', true);
      } else {
        this.UI.checkboxes[group].prop('checked', false);
      }
    }
  }

  initPublicAPI () {
    window.tomjakCookieBanner = {
      giveConsentAndSave: (type) => this.giveConsentAndSave(type),
      giveConsentAndSaveAndLoad: (type) => this.giveConsentAndSave(type, true),
      showExtendedPopup: () => this.showExtendedPopup,
      getConsentStatus: (type) => this.getConsentStatus(type)
    };
  }

  showPopup () {
    this.UI.basicWindow.removeClass('is-hidden');
  }

  closePopup () {
    this.UI.basicWindow.addClass('is-hidden');
  }

  showExtendedPopup () {
    this.UI.extendedWindow.removeClass('is-hidden');
    $(document.body).addClass('no-scroll');
    this.setCheckboxes();
  }

  closeExtendedPopup () {
    this.UI.extendedWindow.addClass('is-hidden');
    $(document.body).removeClass('no-scroll');
  }

  giveConsentForAll () {
    this.giveConsent('google');
    this.saveConsentConfigInCookie(false);
  }

  giveConsent (type, forceOnLoad = false) {
    if (this.config.debugMode) {
      console.log('✅ User gave consent:', type);
    }

    this.config.userConsents[type] = true;

    if (type === 'google') {
      this.allowGoogle();
      return;
    }
  }

  giveConsentAndSave (type, forceOnLoad = false) {
    this.giveConsent(type, forceOnLoad);
    this.saveConsentConfigInCookie(false);
  }

  saveConsent () {
    let consentCompare = this.compareConsents();
    this.setConsentBasedOnCheckboxes();

    // if some consent has been removed
    if (consentCompare === 'some-rejected') {
      this.saveConsentConfigInCookie(true);
      return;
    }

    // otherwise - if some consent has been added
    this.saveConsentConfigInCookie(false);
  }

  setConsentBasedOnCheckboxes () {
    for (let i = 0; i < this.config.groups.length; i++) { 
      let group = this.config.groups[i];

      if (!!this.UI.checkboxes[group].prop('checked')) {
        this.giveConsent(group);
      }
      
      this.config.userConsents[group] = !!this.UI.checkboxes[group].prop('checked');
    }
  }

  saveConsentConfigInCookie (reloadNeeded = false) {
    let configToSave = [];

    for (let i = 0; i < this.config.groups.length; i++) {
      let group = this.config.groups[i];

      if (this.config.userConsents[group]) {
        configToSave.push(group);
      }
    }

    if (configToSave.length) {
      Cookies.set('fwk-cn-config-v1', configToSave.join(';') + '||' + this.config.userUUID, { expires: 180 });

      if (this.config.debugMode) {
        console.log('🍪 Consent config saved in the cookie');
      }
    } else {
      Cookies.set('fwk-cn-config-v1', 'null' + '||' + this.config.userUUID, { expires: 180 });
    }

    let dataToSave = {
      consent_id: this.config.userUUID,
      consent_revision: 'fwk-cn-config-v1',
      consent_content: configToSave.join(';'),
      consent_timestamp: +new Date(),
      url: window.location.pathname,
      delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
    };

    if ('sendBeacon' in navigator) {
      const formData = $.param(dataToSave);
      const blob = new Blob(
        [formData], 
        {
            type : 'application/x-www-form-urlencoded'
        }
      );
      navigator.sendBeacon('https://' + window.location.hostname + '/wp-json/cmp/v1/save', blob);
      
      if (reloadNeeded) {
          window.location.reload();
      }
    } else {
      $.ajax({
        url: 'https://' + window.location.hostname + '/wp-json/cmp/v1/save',
        type: 'POST',
        contentType: 'application/x-www-form-urlencoded',
        data: $.param(dataToSave),
        success: function () {
          if (reloadNeeded) {
              window.location.reload();
          }
        },
        fail: function () {
          if (reloadNeeded) {
              window.location.reload();
          }
        }
      });
    }
  }

  resetCookieConfig () {
    Cookies.set('fwk-cn-config-v1', 'null' + '||' + this.config.userUUID, { expires: 180 });

    if (this.config.debugMode) {
      console.log('🗑 User rejected all cookies - save empty config cookie');
    }

    let dataToSave = {
      consent_id: this.config.userUUID,
      consent_revision: 'fwk-cn-config-v1',
      consent_content: '',
      consent_timestamp: +new Date(),
      url: window.location.pathname,
      delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
    };

    if ('sendBeacon' in navigator) {
      const formData = $.param(dataToSave);
      const blob = new Blob(
        [formData], 
        {
            type : 'application/x-www-form-urlencoded'
        }
      );
      navigator.sendBeacon('https://' + window.location.hostname + '/wp-json/cmp/v1/save', blob);
    } else {
      $.ajax({
        url: 'https://' + window.location.hostname + '/wp-json/cmp/v1/save',
        type: 'POST',
        contentType: 'application/x-www-form-urlencoded',
        data: $.param(dataToSave)
      });
    }
  }

  compareConsents () {
    let someRejected = false;

    for (let i = 0; i < this.config.groups.length; i++) {
      let group = this.config.groups[i];

      if (this.config.userConsents[group] && !this.UI.checkboxes[group].prop('checked')) {
        someRejected = true;
      }
    }

    if (someRejected) {
      if (this.config.debugMode) {
        console.log('🔄 Some consents has been rejected - website reload needed');
      }

      return 'some-rejected';
    }

    if (this.config.debugMode) {
      console.log('ℹ️ User not rejected any consents - website reload not needed');
    }

    return 'some-added-or-not-changed';
  }

  getConsentStatus (type) {
    return !!this.config.userConsents[type];
  }

  allowGoogle () {
    if (window.tomjakUnlocked.indexOf('google') > -1) {
      return;
    }

    window.tomjakUnlockConsentedScript('google', 'head', true);
  }

  generateUUID () {
    var crypto = window.crypto || window.msCrypto;

    if (crypto && crypto.randomUUID) {
        let uuid = crypto.randomUUID();
        return uuid;
    }

    if (window.Uint8Array && crypto && crypto.getRandomValues) {
        let bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;
        let uuid = Array.prototype.map.call(bytes, (b, i) => {
            return ((b < 16) ? '0' : '') + b.toString(16) + (((i % 2) && (i < 10) && (i > 2)) ? "-" : "");
        }).join('');
        return uuid;
    }

    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c == 'x' ? r : (r&0x3|0x8)).toString(16);
    });

    return uuid;
  }
}
